export default __webpack_public_path__ + "static/media/Apple iPad Pro.7bdaa442.png";